import Box from "@mui/material/Box";
import { Tooltip } from "@mui/material";
import React from "react";
import vlrLogo from "./vlr-logo.png";

export default function VlrIcon(props: { size?: number; title?: string; sx?: any }) {
    const size = props.size || 28;

    const label = props.title ?? "VLR";
    const icon = (
            <Box
                component="img"
                src={vlrLogo}
                alt="VLR"
                sx={{
                    width: size,
                    height: size,
                    minWidth: size,
                    minHeight: size,
                    objectFit: "contain",
                    display: "block",
                    ...props.sx,
                }}
            />
    );
    if (props.title === "") return icon;
    return (
        <Tooltip title={label} followCursor>
            {icon}
        </Tooltip>
    );
}
